import { isMobileApp, mobileAppInfo } from "@/shared/mobileHelper";
import { browserInfo } from "@/shared/browserDetect";
import { AppInfo } from "@/shared/types";

export const detectDevice = (): AppInfo => {
  return isMobileApp() ? mobileAppInfo() : browserInfo();
};
